export default __webpack_public_path__ + "static/media/portfolio1.1e0d01c6.png";